module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.className,
    attrs: {
      "href": _vm.href
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-966f7b10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiNavbarLink.vue
// module id = 69
// module chunks = 0